// extracted by mini-css-extract-plugin
export default {"pastDue35":"loandetails_pastDue35__JyxEj","tbody":"loandetails_tbody__tK7wO","pastDue25":"loandetails_pastDue25__zYfL8","pastDue15":"loandetails_pastDue15__p3RB9"};